module.exports = __webpack_public_path__ + "static/img/Jai-Arrow.adda8f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jai-Arrow.jpg
// module id = tHWn
// module chunks = 0